import React from 'react';
import type { IconProps } from '../types';

export const PointerSync = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-pointer-sync"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="28"
        height="28"
      ></rect>
      {/* Pointer/Cursor */}
      <path
        d="M7 4 L7 18 L11 14 L13.5 19.5 L15.5 18.5 L13 13 L17 13 Z"
        id="Pointer"
        fill="currentColor"
      ></path>
      {/* Sync arrows - top right */}
      <path
        d="M19 8 L21.5 8 L21.5 10.5 M21.5 8 C20.5 9 19.5 9.5 18.5 9.5"
        id="SyncArrow1"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      ></path>
      {/* Sync arrows - bottom right */}
      <path
        d="M21.5 20 L19 20 L19 17.5 M19 20 C20 19 21 18.5 22 18.5"
        id="SyncArrow2"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      ></path>
    </g>
  </svg>
);

export default PointerSync;
